// extracted by mini-css-extract-plugin
export default {"app":"App_app__LLm-w","app__main":"App_app__main__r3kpx"};